export default {
  CREATE_ADMIN_LEAGUE_INIT: (state) => {
    state.createAdminLeague = { data: null, loading: true, error: null };
  },
  CREATE_ADMIN_LEAGUE_SUCCESS: (state, data) => {
    state.createAdminLeague.data = data;
    state.createAdminLeague.loading = false;
  },
  CREATE_ADMIN_LEAGUE_ERROR: (state, error) => {
    state.createAdminLeague.error = error;
    state.createAdminLeague.loading = false;
  },
  APPEND_LEAGUES_TO_LEAGUES: (state, payload) => {
    if (state.leagues.data)
      state.leagues.data = [...state.leagues.data, payload];
  },
  GET_LEAGUES_INIT: (state) => {
    state.leagues = { data: [], loading: true, error: null };
  },
  GET_LEAGUES_SUCCESS: (state, data) => {
    state.leagues.data = data;
    state.leagues.loading = false;
  },
  GET_LEAGUES_ERROR: (state, error) => {
    state.leagues.error = error;
    state.leagues.loading = false;
  },
  GET_MORE_LEAGUES_START: (state) => {
    state.moreLeaguesLoading = true;
  },
  GET_MORE_LEAGUES_SUCCESS: (state) => {
    state.moreLeaguesLoading = false;
  },
  GET_MORE_LEAGUES_ERROR: (state) => {
    state.moreLeaguesLoading = false;
  },
  GET_PENDING_INVITATIONS_INIT: (state) => {
    state.pendingProfileInvitations = { data: [], loading: true, error: null };
  },
  APPEND_PENDING_PROFILE_INVITATIONS: (state, data) => {
    state.pendingProfileInvitations.data = data;
    state.pendingProfileInvitations.loading = false;
  },
  GET_PENDING_INVITATIONS_ERROR: (state, err) => {
    state.pendingProfileInvitations.error = err;
    state.pendingProfileInvitations.loading = false;
  },
  REMOVE_ANSWERED_INVITATION: (state, payload) => {
    const invitationIndex = state.pendingProfileInvitations.data.findIndex(
      (invitation) => {
        return invitation.leagueInvitationId === payload.leagueInvitationId;
      }
    );
    if (invitationIndex !== -1) {
      state.pendingProfileInvitations.data.splice(invitationIndex, 1);
    }
  },
  // TODO from Nikola: remove the use of the INIT pattern
  GET_LEAGUE_BY_ID_INIT: (state) => {
    state.league = {
      data: [],
      loading: true,
      error: null,
      feed: {
        data: null,
        loading: false,
        error: null,
        loadingNextPosts: false,
        leagueId: null,
      },
    };
  },
  GET_LEAGUE_BY_ID_SUCCESS: (state, data) => {
    state.league.data = data;
    state.league.loading = false;
  },
  GET_LEAGUE_BY_ID_ERROR: (state, error) => {
    state.league.error = error;
    state.league.loading = false;
  },
  GET_LEAGUE_RULES_BY_ID_INIT: (state) => {
    state.leagueRules = { data: null, loading: true, error: null };
  },
  GET_LEAGUE_RULES_BY_ID_SUCCESS: (state, data) => {
    state.leagueRules.data = data;
    state.leagueRules.loading = false;
  },
  GET_LEAGUE_RULES_BY_ID_ERROR: (state, error) => {
    state.leagueRules.error = error;
    state.leagueRules.loading = false;
  },
  GET_MY_LEAGUE_PORTFOLIOS_INIT: (state) => {
    state.myLeaguePortfolios = { data: [], loading: true, error: null };
  },
  GET_MY_LEAGUE_PORTFOLIOS_SUCCESS: (state, data) => {
    state.myLeaguePortfolios.data = data;
    state.myLeaguePortfolios.loading = false;
  },
  GET_MY_LEAGUE_PORTFOLIOS_ERROR: (state, error) => {
    state.myLeaguePortfolios.error = error;
    state.myLeaguePortfolios.loading = false;
  },
  GET_LEAGUE_PORTFOLIOS_INIT: (state) => {
    state.leaguePortfolios = { data: [], loading: true, error: null };
  },
  GET_LEAGUE_PORTFOLIOS_SUCCESS: (state, data) => {
    if (!state.leaguePortfolios || state.leaguePortfolios.length === 0) {
      state.leaguePortfolios.data = data;
    } else {
      state.leaguePortfolios.data = [...state.leaguePortfolios.data, ...data];
    }
    state.leaguePortfolios.loading = false;
  },
  GET_LEAGUE_PORTFOLIOS_ERROR: (state, error) => {
    state.leaguePortfolios.error = error;
    state.leaguePortfolios.loading = false;
  },
  SUBMIT_LEAGUE_PASSWORD_INIT: (state) => {
    state.submitLeaguePassword = { data: null, loading: true, error: null };
  },
  SUBMIT_LEAGUE_PASSWORD_SUCCESS: (state, data) => {
    state.submitLeaguePassword.data = data;
    if (state.league.data) state.league.data.isJoined = true;
    state.submitLeaguePassword.loading = false;
  },
  SUBMIT_LEAGUE_PASSWORD_FAILED: (state, error) => {
    state.submitLeaguePassword.error = error;
    state.submitLeaguePassword.loading = false;
  },
  SUBMIT_LEAGUE_PASSWORD_ERROR: (state, error) => {
    state.submitLeaguePassword.error = error;
    state.submitLeaguePassword.loading = false;
  },
  GET_LEAGUE_FEED_START: (state, leagueId) => {
    if (!leagueId) {
      throw new Error('GET_LEAGUE_FEED_START: leagueId is required');
    }
    const isSameLeague = state.league.feed.leagueId === leagueId;
    state.league.feed = {
      data: isSameLeague ? state.league.feed.data : null,
      loading: true,
      error: null,
      loadingNextPosts: false,
      leagueId,
    };
  },
  GET_LEAGUE_FEED_SUCCESS: (state, { data, leagueId }) => {
    state.league.feed.data = data;
    state.league.feed.leagueId = leagueId;
  },
  GET_LEAGUE_FEED_ERROR: (state, error) => {
    state.league.feed.error = error;
  },
  SET_LEAGUE_FEED_LOADING: (state, loading) => {
    state.league.feed.loading = loading;
  },
  SET_NEXT_FEED_POSTS_LOADING: (state, loading) => {
    state.league.feed.loadingNextPosts = loading;
  },
  GET_NEXT_FEED_POSTS_SUCCESS: (state, data) => {
    state.league.feed.data = [...state.league.feed.data, ...data];
  },
  APPEND_NEW_POST_AT_TOP: (state, post) => {
    if (state.league.feed.data) {
      state.league.feed.data = [post, ...state.league.feed.data];
    }
  },
  UPDATE_POST_AFTER_EDIT: (state, payload) => {
    if (!state.league.feed.data) return;
    const postIndex = state.league.feed.data.findIndex(
      (e) => e.postId === payload.postId
    );
    if (postIndex !== -1) {
      // Reassigning replyCount and replies to the updated post, since the API doesn't return them in the response for an edited post
      const existingPost = state.league.feed.data[postIndex];
      payload.replyCount = existingPost.replyCount;
      if (existingPost.replies) payload.replies = existingPost.replies;
      state.league.feed.data.splice(postIndex, 1, payload);
    }
  },
  UPDATE_POST_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.league.feed.data) return;

    const postToUpdate = state.league.feed.data.find(
      (post) => post.postId === payload.postId
    );

    if (!postToUpdate) return;

    const newLikedState = !payload.isLiked;

    postToUpdate.isLiked = newLikedState;

    postToUpdate.likeCount = newLikedState
      ? (postToUpdate.likeCount += 1)
      : (postToUpdate.likeCount -= 1);
  },
  UPDATE_POST_LIKE: (state, payload) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find(
      (post) => post.postId === payload.postId
    );
    if (!post) return;

    post.isLiked = payload.isLiked;
    post.likeCount = payload.likeCount;
  },
  ROLLBACK_POST_LIKE: (state, payload) => {
    if (!state.league.feed.data) return;

    const postToUpdate = state.league.feed.data.find(
      (p) => p.postId === payload.postId
    );

    if (!postToUpdate) return;

    postToUpdate.isLiked = payload.isLiked;
    postToUpdate.likeCount = payload.likeCount;
  },
  UPDATE_POST_FAVORITE: (state, payload) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find(
      (e) => e.postId === payload.postId
    );

    if (post) {
      post.isFavorited = payload.isFavorited;
    }
  },
  UPDATE_REPLY_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find(
      (p) => p.postId === payload.postId
    );

    if (!post) return;

    const replyToUpdate = post.replies?.find(
      (r) => r.postId === payload.replyId
    );

    if (!replyToUpdate) return;

    const newLikedState = !payload.replyIsLiked;

    replyToUpdate.isLiked = newLikedState;
    replyToUpdate.likeCount = newLikedState
      ? (replyToUpdate.likeCount += 1)
      : (replyToUpdate.likeCount -= 1);
  },
  UPDATE_REPLY: (state, data) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find((e) => e.postId === data.target);

    if (post) {
      const index = post.replies.findIndex((e) => e.postId === data.postId);
      if (index !== -1) {
        const res = [...post.replies];
        res[index] = data;
        post.replies = res;
      }
    }
  },
  UPDATE_REPLY_AFTER_EDIT: (state, payload) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find(
      (e) => e.postId === payload.postId
    );
    if (post) {
      const replyIndex = post.replies.findIndex(
        (e) => e.postId === payload.data.postId
      );
      if (replyIndex !== -1) {
        payload.data.replyCount = post.replies[replyIndex].replyCount;
        if (post.replies[replyIndex].replies)
          payload.data.replies = post.replies[replyIndex].replies;
        post.replies.splice(replyIndex, 1, payload.data);
      }
    }
  },
  ROLLBACK_REPLY_LIKE: (state, payload) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find(
      (p) => p.postId === payload.postId
    );

    if (!post) return;

    const replyToUpdate = post.replies?.find(
      (r) => r.postId === payload.replyId
    );

    if (!replyToUpdate) return;

    replyToUpdate.isLiked = payload.replyIsLiked;
    replyToUpdate.likeCount = payload.replyLikeCount;
  },
  APPEND_NEW_REPLY: (state, payload) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find(
      (e) => e.postId === payload.target
    );
    if (!post) return;

    if (!post.replies) post.replies = [];

    // In order to keep displaying 2 replies in the feed we only keep the first reply and add the new one on top of it
    const newArray = post.replies.slice(0, 1);
    post.replies = [payload, ...newArray];
    post.replyCount++;
  },
  DELETE_USER_POST_SUCCESS: (state, postId) => {
    if (!state.league.feed.data) return;

    const postIndex = state.league.feed.data.findIndex(
      (e) => e.postId === postId
    );

    if (postIndex !== -1) {
      state.league.feed.data.splice(postIndex, 1);
    }
  },
  DELETE_POST_REPLY_SUCCESS: (state, payload) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find(
      (p) => p.postId === payload.postId
    );

    if (!post) return;

    const replyIndex = post.replies?.findIndex(
      (r) => r.postId === payload.replyId
    );

    if (replyIndex !== -1) {
      // TODO from Nikola: the equivalent mutations in the other feed modules still
      // could decrement replyCount under 0 - worth fixing there too.
      post.replyCount = Math.max(0, post.replyCount - 1);
      post.replies.splice(replyIndex, 1);
    }
  },
  APPEND_NESTED_REPLY_TOP: (state, payload) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find(
      (e) => e.postId === payload.postId
    );

    if (post) {
      const reply = post.replies?.find((r) => r.postId === payload.data.target);

      if (reply) {
        if (!reply.replies) {
          reply.replies = [payload.data];
        } else {
          reply.replies = [payload.data, ...reply.replies];
        }
      }
    }
  },
  INCREMENT_REPLY_REPLY_COUNT: (state, payload) => {
    if (!state.league.feed.data) return;

    const post = state.league.feed.data.find(
      (e) => e.postId === payload.postId
    );

    if (post) {
      const reply = post.replies?.find((r) => r.postId === payload.replyId);
      if (reply) {
        reply.replyCount++;
      }
    }
  },
};
